import { c as _c } from "react/compiler-runtime";
import { LinkButton } from '@onefootprint/ui';
type ShowMoreButtonProps = {
  children: string;
  showAllCta: boolean;
  onClick: () => void;
  count: string;
};
const ShowMoreButton = t0 => {
  const $ = _c(9);
  const {
    children,
    showAllCta,
    onClick,
    count
  } = t0;
  let t1;
  if ($[0] !== count || $[1] !== showAllCta) {
    t1 = showAllCta ? null : <><p className="text-center text-tertiary text-body-2">{count}</p><p className="text-center text-tertiary text-label-2">⋅</p></>;
    $[0] = count;
    $[1] = showAllCta;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children || $[4] !== onClick) {
    t2 = <LinkButton onClick={onClick} variant="label-2">{children}</LinkButton>;
    $[3] = children;
    $[4] = onClick;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="flex justify-center gap-2 py-3 border-t border-dashed border-tertiary">{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default ShowMoreButton;